import en from './translations/en.json'
import fr from './translations/fr.json'
import enApartment from './translations/en.apartment.json'
import frApartment from './translations/fr.apartment.json'
export default {
    en,
    fr,
    en_apartment: enApartment,
    fr_apartment: frApartment,
}
